<!-- =========================================================
     PAGE: QCI (left col) + CSRD (right col) � side by side
     ========================================================= -->
<div class="landscape-two-col-page"
     *ngIf="((qciResultsDto !== null && qciResultsDto != undefined && isModuleAccessible(modulesEnum.Gwp)) ||
            (csrdResultsDto !== null && csrdResultsDto != undefined)) && selectedsubmenu !== 'materialpassport'">
  <div class="row landscape-indicators-row">

    <!-- -----------------QCI col------------------------------- -->
    <div class="col-6 landscape-indicator-col" [class.has-two-indicators]="
        qciResultsDto && isModuleAccessible(modulesEnum.Gwp) && csrdResultsDto"
         *ngIf="qciResultsDto !== null && qciResultsDto != undefined && isModuleAccessible(modulesEnum.Gwp)">
      <div class="indicator-container h-100" style="margin-right: 50px; ">

        <div class="hnn_header_container">
          <img [src]="'../../../assets/img/bw-xi-qci.svg'"
               class="element-icon" aria-hidden="false"
               [attr.aria-label]="'../../../assets/img/bw-xi-qci.svg'" alt="QCI icon">
          <h2 class="hnn_header mb-0">
            <strong>{{'EXTRA_INDICATOR_RESULT.QCI_HEADER' | translate }}</strong>
          </h2>
        </div>

        <div class="parent-container">

          <div class="gwp-container">
            <h2 class="gwp-title">
              {{'EXTRA_INDICATOR_RESULT.QCI_GWP_TOTAL' | translate }}
              <span class="gwp-value">{{totalValue | number:'1.0-0'}}</span>
              <span class="show_warningicon" *ngIf="isTotalValueHigherThanLimitValue && limitValue">
                <img [src]="'../../../../assets/img/warning.svg'" class="warning_triangle_img" />
              </span>
            </h2>
            <p class="gwp-description" [innerHTML]="'EXTRA_INDICATOR_RESULT.QCI_EMISSION_UNIT' | translate | fixDimensions"></p>
          </div>
          <div class="child-container pb-1">
            <div class="progress-container-qci">

              <div *ngIf="!isTotalValueHigherThanLimitValue" [ngClass]="'tooltip_limit_div'">
                <div class="arrow_box arrow_box_right">{{'EXTRA_INDICATOR_RESULT.QCI_LIMIT_VALUE' | translate }} <span class="text-dark">{{limitValue | number:'1.0-0'}}</span></div>
              </div>

              <div [style.margin-left]="14 + '%'" *ngIf="isTotalValueHigherThanLimitValue"
                   [ngClass]="limitValue == null ? 'progress-tooltip-fortotal' : ['progress-tooltip-warning', 'text-danger']">
                Totaal:
                <span [ngClass]="limitValue == null ? '' : 'text-danger'">{{totalValue | number:'1.0-0'}}</span>
              </div>

              <div class="progress-bar-qci light-blue" *ngIf="isTotalValueHigherThanLimitValue" [style.width]="totalLimitWidth + '%'"></div>

              <div *ngIf="!isBlueHigherThanLimit" class="progress-bar-qci blue" [style.width]="totalBlueWidth + '%'"
                   [ngClass]="totalBlueWidth > 99.99 ? 'border-blue-radius-full' : 'border-blue-radius'"></div>

              <div *ngIf="isBlueHigherThanLimit" class="progress-bar-qci blue" [style.width]="totalLimitWidth + '%'"
                   style="background-color: #333E86; z-index: 1; border-radius: 20px 1px 1px 20px;"
                   [ngClass]="totalBlueWidth > 99.99 ? 'border-blue-radius-full' : 'border-blue-radius'"></div>
              <div *ngIf="isBlueHigherThanLimit || isOrangeHigherThanLimit" class="progress-bar-qci blue"
                   style="background-color: #5f6cbe" [style.width]="(totalBlueWidth) + '%'"
                   [ngClass]="totalBlueWidth > 99.99 ? 'border-blue-radius-full' : 'border-blue-radius'"></div>

              <div *ngIf="!isOrangeHigherThanLimit" class="progress-bar-qci orange" [style.width]="totalOrangeWidth + '%'"
                   style="background-color: #FF7A00; z-index: 1; border-radius: 20px 1px 1px 20px;"
                   [ngClass]="totalOrangeWidth > 99.99 ? 'border-orange-radius-full' : 'border-orange-radius'"></div>
              <div *ngIf="isOrangeHigherThanLimit" class="progress-bar-qci orange" [style.width]="totalLimitWidth + '%'"
                   style="background-color: #FF7A00; z-index: 1; border-radius: 20px 1px 1px 20px;"
                   [ngClass]="totalOrangeWidth > 99.99 ? 'border-orange-radius-full' : 'border-orange-radius'"></div>
              <div *ngIf="isOrangeHigherThanLimit" class="progress-bar-qci orange" style="background-color: #dea36d"
                   [style.width]="(totalOrangeWidth) + '%'"
                   [ngClass]="totalOrangeWidth > 99.99 ? 'border-orange-radius-full' : 'border-orange-radius'"></div>

              <div class="progress-dotted-line" [style.left]="getLightBlueWidth() + '%'" *ngIf="limitValue">
                <div class="progress-tooltip" *ngIf="!isTotalValueHigherThanLimitValue">
                  {{'EXTRA_INDICATOR_RESULT.QCI_TOTAL_VALUE' | translate }}
                  <span class="text-dark">{{totalValue | number:'1.0-0'}}</span>
                </div>
                <div *ngIf="isTotalValueHigherThanLimitValue" class="arrow_box limit_exceed_total">
                  {{'EXTRA_INDICATOR_RESULT.QCI_LIMIT_VALUE' | translate }}
                  <span class="text-dark">{{limitValue | number:'1.0-0'}}</span>
                </div>
              </div>

              <div class="progress-dotted-line-end" [style.color]="isTotalValueHigherThanLimitValue && limitValue ? 'red' : '#2740b0'"></div>
            </div>
          </div>

        </div>


        <div class="row no-gutters mt-5">
          <div class="csrd_emission_sources justify_content">
            <span class="emission-dot-spacer"></span>
            <span class="emission-source-name-col" style="font-size:9px">{{'EXTRA_INDICATOR_RESULT.QCI_EMISSION_SOURCES' | translate }}</span>
            <span style="margin-left:220px" [innerHTML]="'EXTRA_INDICATOR_RESULT.QCI_EMISSION_UNIT'| translate| fixDimensions"></span>
          </div>
          <ul>
            <li class="emission-title">
              <span class="informative_dot blue"></span>
              <span class="emission-source-name-col">{{'EXTRA_INDICATOR_RESULT.QCI_GWP_ENERGY' | translate}}</span>
              <span class="mr-4 text_align_right">{{qci_energy | number:'1.0-0'}}</span>
            </li>
            <li class="emission-title">
              <span class="informative_dot orange"></span>
              <span class="emission-source-name-col">{{'EXTRA_INDICATOR_RESULT.QCI_GWP_MATERIAL' | translate}}</span>
              <span class="mr-4 text_align_right">{{qci_gwp_material | number:'1.0-0'}}</span>
            </li>
            <li class="emission-title">
              <span class="informative_dot green"></span>
              <span class="emission-source-name-col">{{'EXTRA_INDICATOR_RESULT.QCI_GWP_BIOGEN' | translate}}</span>
              <span class="mr-4 text_align_right">{{qci_biogen | number:'1.0-0'}}</span>
            </li>
          </ul>
        </div>

        <div class="row no-gutters qci_userinput_container mt-3">
          <div class="col-12">
            <div class="row no-gutters qci_userinput_header">
              <div class="col-12">{{'PRINT_PAGE.SUMMARY_INPUT' | translate }}</div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                  <div class="col-8">{{'PRINT_PAGE.QCI_INPUT_JAARVANOP' | translate }}</div>
                  <div class="col-4 text_align_right">{{extraIndicatorsUserInputDto?.qciAmpInput?.yearOfDelivery }}</div>
                </div>
                <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                  <div class="col-8">{{'PRINT_PAGE.QCI_INPUT_ASDESIGNED' | translate }}</div>
                  <div class="col-4 text_align_right">
                    {{ (extraIndicatorsUserInputDto?.qciAmpInput?.asDesigned ? 'PRINT_PAGE.AS_DESIGNED_INPUT_VALUE_YES' : 'PRINT_PAGE.AS_DESIGNED_INPUT_VALUE_NO') | translate }}
                  </div>
                </div>
                <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                  <div class="col-8">{{'PRINT_PAGE.QCI_INPUT_EP2' | translate }}</div>
                  <div class="col-4 text_align_right">{{extraIndicatorsUserInputDto?.qciAmpInput?.primaryFossilEnergyUseEp2 | number:'.2-2' }}</div>
                </div>

                <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                  <div class="col-8">{{'PRINT_PAGE.QCI_INPUT_BIOGENICCO2STORAGELONGGROWTH' | translate }}</div>
                  <div class="col-4 text_align_right">
                    {{extraIndicatorsUserInputDto?.qciAmpInput?.biogenicCo2StorageShortGrowth }}
                    {{'PRINT_PAGE.QCI_INPUT_BIOGEN_UNIT' | translate }}
                  </div>
                </div>
                <div class="row hnn_element_row no-gutters qci_userinput_row_element">
                  <div class="col-8">{{'PRINT_PAGE.QCI_INPUT_BIOGENCO2STORAGESHORTGROWTH' | translate }}</div>
                  <div class="col-4 text_align_right">
                    {{extraIndicatorsUserInputDto?.qciAmpInput?.biogenicCo2StorageLongGrowth }}
                    {{'PRINT_PAGE.QCI_INPUT_BIOGEN_UNIT' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div><!-- /QCI col -->
    <!-- -----------------CSRD col------------------------------- -->
    <div class="col-6 landscape-indicator-col" [class.has-two-indicators]="
        qciResultsDto && isModuleAccessible(modulesEnum.Gwp) && csrdResultsDto"
         *ngIf="csrdResultsDto !== null && csrdResultsDto != undefined">
      <div class="indicator-container h-100">

        <div class="hnn_header_container">
          <img [src]="'../../../assets/img/bw-xi-csrd.svg'"
               class="element-icon" aria-hidden="false"
               [attr.aria-label]="'../../../assets/img/bw-xi-csrd.svg'" alt="CSRD icon">
          <h2 class="hnn_header mb-0">
            CSRD rapportage
          </h2>
        </div>

        <div class="csrd_body_container mt-5">
          <div class="csrd_emission_sources">
            <span class="firstcolumn" style="font-size:9px">{{'EXTRA_INDICATOR_RESULT.QCI_EMISSION_SOURCES' | translate }}</span>
            <span class="secondcolumnheader">ton CO<sub>2</sub> eq</span>
          </div>

          <div class="emission-row">
            <div class="firstcolumnwidth">
              <div class="emission-label">
                <div class="hnn_icon"><img [src]="'../../../../assets/img/bw-xi-purchasing_goods_services.svg'"></div>
                <span>{{'EXTRA_INDICATOR_RESULT.CSRD_PURCHASING_GOODS_SERVICE' | translate}}</span>
              </div>
            </div>
            <div class="min_width">
              <span class="emission-value fw-bold emission_value_left">{{ csrdResultsDto?.cat1Procurement | number:'1.0-0' }}</span>
            </div>
            <div class="progress-container">
              <div class="progress-bar" [style.backgroundColor]="'#00BBB9'" [style.width]="calculatePercentage(csrdResultsDto?.cat1Procurement, maxEmission) + '%'"></div>
            </div>
          </div>

          <div class="emission-row">
            <div class="firstcolumnwidth">
              <div class="emission-label">
                <div class="hnn_icon"><img [src]="'../../../../assets/img/bw-xi-transport.svg'"></div>
                <span>{{'EXTRA_INDICATOR_RESULT.CSRD_TRANSPORT' | translate}}</span>
              </div>
            </div>
            <div class="min_width">
              <span class="emission-value fw-bold emission_value_left">{{ csrdResultsDto?.cat4Transport | number:'1.0-0' }}</span>
            </div>
            <div class="progress-container">
              <div class="progress-bar" [style.backgroundColor]="'#FFB500'" [style.width]="calculatePercentage(csrdResultsDto?.cat4Transport, maxEmission) + '%'"></div>
            </div>
          </div>

          <div class="emission-row">
            <div class="firstcolumnwidth">
              <div class="emission-label">
                <div class="hnn_icon"><img [src]="'../../../../assets/img/bw-xi-result-csrd-usage_sold_products.svg'"></div>
                <span>{{'EXTRA_INDICATOR_RESULT.CSRD_USAGE_OF_SOLD_PRODUCT' | translate}}</span>
              </div>
            </div>
            <div class="min_width">
              <span class="emission-value fw-bold emission_value_left">{{ csrdResultsDto?.cat11UseOfSoldProducts | number:'1.0-0' }}</span>
            </div>
            <div class="progress-container">
              <div class="progress-bar" [style.backgroundColor]="'#FF7A00'" [style.width]="calculatePercentage(csrdResultsDto?.cat11UseOfSoldProducts, maxEmission) + '%'"></div>
            </div>
          </div>

          <div class="emission-row">
            <div class="firstcolumnwidth">
              <div class="emission-label">
                <div class="hnn_icon"><img [src]="'../../../../assets/img/bw-xi-result-csrd-end_of_life.svg'"></div>
                <span>{{'EXTRA_INDICATOR_RESULT.CSRD_END_OF_LIFE' | translate}}</span>
              </div>
            </div>
            <div class="min_width">
              <span class="emission-value fw-bold emission_value_left">{{ csrdResultsDto?.cat12EndOfLifeTreatment | number:'1.0-0' }}</span>
            </div>
            <div class="progress-container">
              <div class="progress-bar" [style.backgroundColor]="'#333E86'" [style.width]="calculatePercentage(csrdResultsDto?.cat12EndOfLifeTreatment, maxEmission) + '%'"></div>
            </div>
          </div>
        </div>

        <div class="mt-5 csrd_userinput_container">
          <div class="csrd_userinput_header"><span>{{'PRINT_PAGE.SUMMARY_INPUT' | translate}}</span></div>
          <div class="emission-row">
            <div class="csrd_userinput_col_left"><span>{{'PRINT_PAGE.QCI_INPUT_ASDESIGNED' | translate}}</span></div>
            <div class="text_align_right csrd_userinput_col_right" style="width:40%">
              {{ (extraIndicatorsUserInputDto?.csrdAmpInput?.asDesigned ? 'PRINT_PAGE.AS_DESIGNED_INPUT_VALUE_YES' : 'PRINT_PAGE.AS_DESIGNED_INPUT_VALUE_NO') | translate }}
            </div>
          </div>
          <div class="emission-row">
            <div class="csrd_userinput_col_left"><span>{{'PRINT_PAGE.QCI_INPUT_EP2' | translate}}</span></div>
            <div class="text_align_right csrd_userinput_col_right">
              {{extraIndicatorsUserInputDto?.csrdAmpInput?.primaryFossilEnergyUseEp2 | number:'.2-2' }}
              <span [innerHTML]="'PRINT_PAGE.CSRD_INPUT_UNIT'| translate| fixDimensions"></span>
            </div>
          </div>
        </div>

      </div>
    </div><!-- /CSRD col -->

  </div><!-- /row -->
</div>


<!-- ----------------- HNN � full landscape page ------------------------------- -->
<div class="page-break-before"
     *ngIf="hnnResultsDto !== null && hnnResultsDto !== undefined && isModuleAccessible(modulesEnum.Hnn)">
  <div class="row landscape-indicators-row">
    <div class="col-12 main-container">

      <mat-card class="section">

        <div class="hnn_header_container">
          <img [src]="'../../../assets/img/bw-xi-hnn.svg'"
               class="element-icon" aria-hidden="false"
               [attr.aria-label]="'../../../assets/img/bw-xi-hnn.svg'" alt="HNN icon">
          <h2 class="hnn_header mb-0">HET NIEUWE NORMAAL (HNN)</h2>
        </div>

        <div class="row hnn-content-row">

          <!-- Left col: four data sections -->
          <div class="col-5 hnn-data-col">

            <div class="col-12">
              <div class="row">
                <div class="section-header col-12">
                  <div class="hnn_icon"><img [src]="'../../../assets/img/hnn-milieu.svg'"></div>
                  <h2 class="text-center mb-0">{{'EXTRA_INDICATOR_RESULT.HNN_MILIEU_IMPACT' | translate}}</h2>
                </div>
                <div class="col-12">
                  <div class="row hnn_element_row no-gutters">
                    <div class="col-11 hnn_element_name"><span [innerHTML]="'EXTRA_INDICATOR_RESULT.HNN_MI_MPG'| translate| fixDimensions"></span></div>
                    <div class="col-1 hnn_element_value">{{ mpg | number:'.3-3' }}</div>
                  </div>
                  <div class="row hnn_element_row no-gutters">
                    <div class="col-11 hnn_element_name"><span [innerHTML]="'EXTRA_INDICATOR_RESULT.HNN_MI_CO2_BVO'| translate| fixDimensions"></span></div>
                    <div class="col-1 hnn_element_value">{{ parisProofIndicator | number:'1.0-0' }}</div>
                  </div>
                  <div class="row hnn_element_last_row no-gutters">
                    <div class="col-11 hnn_element_name"><span [innerHTML]="'EXTRA_INDICATOR_RESULT.HNN_MI_CO2'| translate| fixDimensions"></span></div>
                    <div class="col-1 hnn_element_value">{{ selectedDataSet == dataSetSetting.A1 ? 'n.v.t.' : (constructionStoredCarbon | number:'1.0-0') }}</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="section-header col-12">
                  <div class="hnn_icon"><img [src]="'../../../assets/img/hnn-valueretention.svg'"></div>
                  <h2 class="text-center mb-0">{{'EXTRA_INDICATOR_RESULT.HNN_WAARDEBEHOUD' | translate}}</h2>
                </div>
                <div class="col-12">
                  <div class="row hnn_element_row no-gutters">
                    <div class="col-11 hnn_element_name">{{'EXTRA_INDICATOR_RESULT.HNN_W_ADAPTIEF' | translate}}</div>
                    <div class="col-1 hnn_element_value">{{ extraIndicatorsUserInputDto?.hnnAmpInput?.adaptability | number:'.2-2' }}%</div>
                  </div>
                  <div class="row hnn_element_row no-gutters">
                    <div class="col-11 hnn_element_name">{{'EXTRA_INDICATOR_RESULT.HNN_W_LOSMAAKBAARHEID' | translate}}</div>
                    <div class="col-1 hnn_element_value">
                      {{ hnnResultsDto?.dismountability | number:'.2-2' }}
                      <span class="blue-dot" *ngIf="  showBlueDot.dismountability"></span>
                    </div>
                  </div>
                  <div class="row hnn_element_last_row no-gutters">
                    <div class="col-11 hnn_element_name">{{'EXTRA_INDICATOR_RESULT.HNN_W_HERGEBRUIKPOTENTIE' | translate}}</div>
                    <div class="col-1 hnn_element_value">
                      {{ hnnResultsDto?.reusePotentialDownstream | number:'1.0-0' }}%
                      <span class="blue-dot" *ngIf="  showBlueDot.futureMaterials"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="section-header col-12">
                  <div class="hnn_icon"><img [src]="'../../../assets/img/hnn-energy.svg'"></div>
                  <h2 class="text-center mb-0">{{'EXTRA_INDICATOR_RESULT.HNN_ENERGIE' | translate}}</h2>
                </div>
                <div class="col-12">
                  <div class="row hnn_element_row no-gutters">
                    <div class="col-11 hnn_element_name"><span [innerHTML]="'EXTRA_INDICATOR_RESULT.HNN_ENERGIE_MAXIMAL_EP1'| translate| fixDimensions"></span></div>
                    <div class="col-1 hnn_element_value">{{extraIndicatorsUserInputDto?.hnnAmpInput?.energyNeedEp1 | number:'.2-2'}}</div>
                  </div>
                  <div class="row hnn_element_row no-gutters">
                    <div class="col-11 hnn_element_name"><span [innerHTML]="'EXTRA_INDICATOR_RESULT.HNN_ENERGIE_PRIMAIR_EP2'| translate| fixDimensions"></span></div>
                    <div class="col-1 hnn_element_value">{{extraIndicatorsUserInputDto?.hnnAmpInput?.primaryFossilEnergyUseEp2 | number:'.2-2'}}</div>
                  </div>
                  <div class="row hnn_element_last_row no-gutters">
                    <div class="col-11 hnn_element_name"><span [innerHTML]="'EXTRA_INDICATOR_RESULT.HNN_ENERGIE_AANDEEL_EP3'| translate| fixDimensions"></span></div>
                    <div class="col-1 hnn_element_value">{{extraIndicatorsUserInputDto?.hnnAmpInput?.renewableEnergyShareEp3 | number:'.2-2'}}%</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="section-header col-12">
                  <div class="hnn_icon"><img [src]="'../../../assets/img/hnn-materiaal.svg'"></div>
                  <h2 class="text-center mb-0">{{'EXTRA_INDICATOR_RESULT.HNN_MATERIAALGEBRUIK' | translate}}</h2>
                </div>
                <div class="col-12">
                  <div class="row hnn_element_row no-gutters">
                    <div class="col-11 hnn_element_name">{{'EXTRA_INDICATOR_RESULT.HNN_MAT_HERKOMST' | translate}}</div>
                    <div class="col-1 hnn_element_value">
                      {{ hnnResultsDto?.originMaterialsUpstream | number:'1.0-0' }}%
                      <span class="blue-dot" *ngIf="  showBlueDot.originMaterials"></span>
                    </div>
                  </div>
                  <div class="row hnn_element_row no-gutters">
                    <div class="col-11 hnn_element_name">{{'EXTRA_INDICATOR_RESULT.HNN_MAT_GEZONDE' | translate}}</div>
                    <div class="col-1 hnn_element_value">{{ extraIndicatorsUserInputDto?.hnnAmpInput?.healthyMaterials | number:'1.0-0' }}</div>
                  </div>
                  <div class="row hnn_element_last_row no-gutters">
                    <div class="col-11 hnn_element_name">{{'EXTRA_INDICATOR_RESULT.HNN_MAT_OMGANG' | translate}}</div>
                    <div class="col-1 hnn_element_value"></div>
                  </div>
                </div>
              </div>


            </div>

          </div><!-- /hnn-data-col -->
          <!-- Right col: sankey chart -->
          <div class="col-7 hnn-chart-col" *ngIf="chartOptions">
            <div echarts
                 [options]="chartOptions"
                 [initOpts]="{ renderer: 'svg' }"
                 class="hnn-sankey-chart"></div>
          </div>

        </div><!-- /row -->

        <div class="col-12">
          <div class="row">
            <div class="col-5">
              <p #content class="content expanded" [innerHTML]="extraIndicatorsUserInputDto?.hnnAmpInput?.handlingResidualMaterials | lineBreak"></p>
            </div>
            <div class="col-7">
              <div class="row notification row-spacing"
                   *ngIf=" (showBlueDot.dismountability || showBlueDot.originMaterials || showBlueDot.futureMaterials)">
                <div class="col-md-12 d-flex">
                  <span class="blue-dot mt-1 me-3"></span>
                  <div class="notification-text">
                    <div><b>{{ 'EXTRA_INDICATOR_RESULT.HNN_MANUAL_ADJUSTMENTS' | translate }}</b></div>
                    <div>
                      {{ 'EXTRA_INDICATOR_RESULT.HNN_MANUAL_ADJUSTMENTS_MESSAGE' | translate: { X: totalUsedProducts, Y: hnnResultsDto?.hnnOverrideStats?.manuallyOverwrittenProducts } }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 hnn_footnote">
          <span>{{ 'EXTRA_INDICATOR_RESULT.HNN_FOOTER_SINGLE' | translate }}</span><br>
          <span>{{ 'EXTRA_INDICATOR_RESULT.HNN_FOOTER' | translate }}</span>

        </div>
       
      </mat-card>
    </div>
  </div>
</div>



<!---------------- WHOLE LIFE CARBON SECTION ----------------------------->
<div class="page-break-before" *ngIf="isWlcIndicatorEnabled && isModuleAccessible(modulesEnum.Gwp)  && selectedsubmenu !== 'materialpassport'">
  <div class="row landscape-indicators-row">
    <div class="col-12">
      <div class="row indicator-container">
        <div class="hnn_header_container">
          <div>
            <ng-container *ngIf="'../../../assets/img/bw-xi-wlc.svg'">
              <img [src]="'../../../assets/img/bw-xi-wlc.svg'"
                   class="element-icon"
                   aria-hidden="false"
                   [attr.aria-label]="'../../../assets/img/bw-xi-wlc.svg'"
                   alt="Dynamic Icon">
            </ng-container>
          </div>

          <h2 class="hnn_header mb-0">
            {{'EXTRA_INDICATOR_RESULT.WLC_HEADER' | translate }}
          </h2>
        </div>

        <div class="message_container mt-5" *ngIf="selectedDataSet == dataSetSetting.A1">
          <h6 class="show_message">{{'EXTRA_INDICATOR_RESULT.WLC_NOT_CALCULATED_WITH_A1' | translate }}</h6>
        </div>


        <div class="col-12" *ngIf="wlcResultsDto != null && wlcResultsDto != undefined">
          <div>
            <div class="wlc-score-wrapper">
              <div class="wlc-score-container">
                <div class="wlc-score-label-container">
                  
                  <div class="wlc-score-box">
                    <p class="wlc-unit-title">GWPtot</p>
                    <div class="score-wrapper">
                      <span class="wlc-score-value">
                        <img [src]="'../../../../assets/img/score1_icon.svg'" class="score_icon" />
                        {{ wlc_total_score | number:'1.0-0' }}
                      </span>
                    </div>
                    <p class="wlc-unit" style="margin-top: 2px;" [innerHTML]="'EXTRA_INDICATOR_RESULT.WLC_UNIT' | translate | fixDimensions"></p>
                  </div>

                  <div class="wlc-score-box">
                    <p class="wlc-unit-title">WLC-GWP</p>
                    <div class="score-wrapper">
                      <span class="wlc-score-value">
                        <img [src]="'../../../../assets/img/score2_icon.svg'" class="score_icon" />
                        {{ wlcScoreByGbo | number:'1.2-2' }}
                      </span>
                    </div>
                    <p class="wlc-unit" style="margin-top: 2px;"  [innerHTML]="'EXTRA_INDICATOR_RESULT.WLC_OP_ENERGIE_EMISSIES_UNIT' | translate | fixDimensions"></p>
                  </div>

                </div>

                <div class="wlc-child-container pt-1">


                  <app-stacked-bar [segments]="wlcTotalScoreSegments"
                                   [total]="wlc_total_score"
                                   [max]="wlc_total_score"
                                   [neutralZonePercent]="10"
                                   [isNegative]="isNegativeTotalScore"
                                   [showZeroLine]="true"
                                   [showLabel]="true">
                  </app-stacked-bar>

                </div>
                <div style="width:35%"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 pt-1" *ngIf="wlcResultsDto != null && wlcResultsDto != undefined">
          <div class="row mt-2">
            <div class="col-8 wlc-details">
              <div class="wlc-mat_emissies-container">
                <div class="wlc-section-header">
                  <div class="wlc-label">
                    <span>{{'EXTRA_INDICATOR_RESULT.WLC_MATERIAALGEBONDEN_EMISSIES' | translate }}</span>
                  </div>
                  <div>
                    <span class="wlc-score-value">{{ wlc_mat_emissies_total | number:'1.0-0' }}</span>
                  </div>
                  <div class="wlc-unit-container">
                    <div class="wlc-unit-inline">
                      <p class="wlc-unit" [innerHTML]="'EXTRA_INDICATOR_RESULT.WLC_UNIT' | translate | fixDimensions"></p>

                    </div>

                  </div>

                </div>

                <div class="zero-line-wrapper">
                  <div class="zero-label">0</div>
                  <div class="zero-line"></div>
                </div>
                <div class="wlc-row" *ngFor="let item of materialEmissions">
                  <div class="wlc-icon">
                    <img [src]="item.iconPath" alt="{{item.label}} icon" />
                  </div>

                  <div class="wlc-label">
                    {{item.label}} <span class="highlight">{{item.code}}</span>
                  </div>
                  <div class="wlc-info-icon">

                  </div>

                  <div class="wlc-value">{{item.value | number:'1.0-0'}}</div>

                  <div class="mirror-bar-wrapper">
                    <div class="mirror-bar"
                         [ngClass]="{ 'left-bar': item.value < 0, 'right-bar': item.value >= 0 }"
                         [style.width.%]="calculateMirrorWidth(item.value, maxValue)"></div>
                  </div>
                </div>
              </div>

              <div class="wlc-mat_emissies-container">
                <div class="wlc-section-header">
                  <div class="wlc-label">
                    <span>{{'EXTRA_INDICATOR_RESULT.WLC_OP_ENERGIE_EMISSIES' | translate }}</span>
                  </div>
                  <div>
                    <span class="wlc-score-value">{{ wlc_op_energy_emissies_total | number:'1.0-0' }}</span>
                  </div>
                  <div class="wlc-unit-container">
                    <div class="wlc-unit-inline">
                      <p class="wlc-unit" [innerHTML]="'EXTRA_INDICATOR_RESULT.WLC_EMISSIES_PER_UNIT' | translate | fixDimensions"></p>

                    </div>

                  </div>

                </div>

                <div class="zero-line-wrapper">
                  <div class="zero-label">0</div>
                  <div class="zero-line"></div>
                </div>
                <div class="wlc-row" *ngFor="let item of operationEmissions; let i = index">
                  <div class="wlc-icon">
                    <img [src]="item.iconPath" alt="{{item.label}} icon" />
                  </div>

                  <div class="wlc-label">
                    {{item.label}} <span class="highlight">{{item.code}}</span>
                  </div>
                  <div class="wlc-info-icon">

                  </div>

                  <div class="wlc-value">{{item.value | number:'1.0-0'}}</div>

                  <div class="mirror-bar-wrapper">
                    <div class="mirror-bar"
                         [ngClass]="{ 'left-bar': item.value < 0, 'right-bar': item.value >= 0 }"
                         [style.width.%]="calculateOperationMirrorWidth(item.value, maxValue)"></div>
                  </div>
                </div>

              </div>

              <!-- WLC Bottom Graphs -->

              <div class="parent-container-wlc">
                <div class="wlc_bottom_left_container">


                  <div class="child-container_left pb-3">

                    <div class="wlc-bar-title">
                      <span class="wlc-title-text"> {{'EXTRA_INDICATOR_RESULT.WLC_TOELEVERING' | translate}} </span>
                      <p class="wlc-unit" [innerHTML]="'EXTRA_INDICATOR_RESULT.WLC_EMISSIES_PER_UNIT' | translate | fixDimensions"></p>
                    </div>

                    <!-- Toelevering -->
                    <app-stacked-bar [segments]="toeleveringSegments"
                                     [total]="wlc_energiegebruik_totalValue"
                                     [max]="barMaxValue">
                    </app-stacked-bar>

                  </div>

                  <div class="child-container_left pb-3">
                    <div class="wlc-bar-title">
                      {{'EXTRA_INDICATOR_RESULT.WLC_TERUGLEVERING' | translate}}
                      <p class="wlc-unit" [innerHTML]="'EXTRA_INDICATOR_RESULT.WLC_EMISSIES_PER_UNIT' | translate | fixDimensions"></p>
                    </div>

                    <!-- Teruglevering -->
                    <app-stacked-bar [segments]="terugleveringSegments"
                                     [total]="wlc_eigenopwekking_totalValue"
                                     [max]="barMaxValue">
                    </app-stacked-bar>

                  </div>


                </div>

                <div class="child-container container-emission">
                  <div class="csrd_emission_sources justify_content">
                    <span class="wlc_emissies_name_col_header">
                      {{ 'EXTRA_INDICATOR_RESULT.WLC_ENERGIE_PER_BRON' | translate }}
                      <span class="wlc-unit">
                        <p [innerHTML]="'EXTRA_INDICATOR_RESULT.WLC_EMISSIES_PER_UNIT' | translate | fixDimensions"></p>
                      </span>
                    </span>

                    <span> {{'EXTRA_INDICATOR_RESULT.WLC_ENERGIEGEBRUIK' | translate }} </span>
                    <span> {{'EXTRA_INDICATOR_RESULT.WLC_EIGEN_OP' | translate }} </span>
                  </div>
                  <ul class="mb-1">
                    <li class="emission-title">
                      <span class="informative_dot blue"></span>
                      <span class="wlc_emissies_name_col">{{'EXTRA_INDICATOR_RESULT.WLC_ELEKTRICITEIT' | translate}}</span>
                      <span class="emission-value">{{wlc_energiegebruik_elektriciteitValue | number:'1.0-0'}}</span>
                      <span class="emission-value">{{wlc_eigenopwekking_elektriciteitValue | number:'1.0-0'}}</span>
                    </li>
                    <li class="emission-title">
                      <span class="informative_dot green"></span>
                      <span class="wlc_emissies_name_col">{{'EXTRA_INDICATOR_RESULT.WLC_GAS' | translate}}</span>
                      <span class="emission-value">{{wlc_energiegebruik_aardgasValue | number:'1.0-0'}}</span>
                      <span class="emission-value">
                        {{ wlc_eigenopwekking_aardgasValue === 0 ? '-' : (wlc_eigenopwekking_aardgasValue | number:'1.0-0') }}
                      </span>

                    </li>
                    <li class="emission-title">
                      <span class="informative_dot orange"></span>
                      <span class="wlc_emissies_name_col">{{'EXTRA_INDICATOR_RESULT.WLC_WARMTE' | translate}}</span>
                      <span class="emission-value">{{wlc_energiegebruik_warmteValue | number:'1.0-0'}}</span>
                      <span class="emission-value">
                        {{ wlc_eigenopwekking_warmteValue === 0 ? '-' : (wlc_eigenopwekking_warmteValue | number:'1.0-0') }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="info-box" *ngIf="wlcResultsDto?.anyProductDeactivated">
                <span class="dot"></span>
                <div class="info-text">
                  <strong>{{'EXTRA_INDICATOR_RESULT.WLC_WARNING_MESSAGE_HEADER' | translate}}</strong><br />
                  <span>{{'EXTRA_INDICATOR_RESULT.WLC_DEACTIVATED_PRODUCT_MESSAGE' | translate}} </span>
                </div>
              </div>
              <!-- End WLC Bottom Graphs-->

            </div>


            <!-- Input Data for WLC-->
            <div class="col-4 wlc-details" style="margin-top:55px">
              <div class="row no-gutters qci_userinput_container">
                <div class="col-12">
                  <div class="row no-gutters qci_userinput_header">
                    <div class="col-12">  {{'PRINT_PAGE.SUMMARY_INPUT' | translate }}  </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                        <div class="col-9">{{'PRINT_PAGE.WLC_ELECTRICIT' | translate }}</div>
                        <div class="col-3 text_align_right">{{extraIndicatorsUserInputDto?.wlcAmpInput?.electricitySupply | number:'1.0-0'}}</div>
                      </div>
                      <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                        <div class="col-9">{{'PRINT_PAGE.QCI_INPUT_ASDESIGNED' | translate }}</div>
                        <div class="col-3 text_align_right">
                          {{ (extraIndicatorsUserInputDto?.wlcAmpInput?.asDesigned ? 'PRINT_PAGE.AS_DESIGNED_INPUT_VALUE_YES' : 'PRINT_PAGE.AS_DESIGNED_INPUT_VALUE_NO') | translate }}
                        </div>
                      </div>
                      <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                        <div class="col-9">{{'PRINT_PAGE.WLC_GAS' | translate }}</div>
                        <div class="col-3 text_align_right">{{extraIndicatorsUserInputDto?.wlcAmpInput?.naturalGasSupply | number:'1.0-0' }}</div>
                      </div>
                    <!--</div>
                    <div class="col-6">-->
                      <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                        <div class="col-6">{{'PRINT_PAGE.WLC_WARMTE' | translate }}</div>
                        <div class="col-6 text_align_right">{{heatSupplyTypeValue }}</div>
                      </div>
                      <div class="row hnn_element_row no-gutters qci_userinput_row_element bottom_border">
                        <div class="col-6">{{'PRINT_PAGE.WLC_WARMTH_INVOER' | translate }}</div>
                        <div class="col-6 text_align_right">
                          {{ extraIndicatorsUserInputDto?.wlcAmpInput?.heatSupply | number:'1.0-0' }}
                        </div>
                      </div>
                      <div class="row hnn_element_row no-gutters qci_userinput_row_element">
                        <div class="col-6">{{'PRINT_PAGE.WLC_OP_ELECTRICITY' | translate }}</div>
                        <div class="col-6 text_align_right">{{extraIndicatorsUserInputDto?.wlcAmpInput?.electricityGenerated | number:'1.0-0' }}</div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              
              <div class="row no-gutters">
                <div class="col-12">
                    <div class="info-box" *ngIf="wlcResultsDto?.anyProductDeactivated">
                        <span class="dot"></span>
                        <div class="info-text">
                            <strong>{{'EXTRA_INDICATOR_RESULT.WLC_WARNING_MESSAGE_HEADER' | translate}}</strong><br />
                            <span>{{'EXTRA_INDICATOR_RESULT.WLC_DEACTIVATED_PRODUCT_MESSAGE' | translate}} </span>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
     
       


      </div>
    </div>
  </div>
</div>



<!-- When no Indicator Selected-->
<div class="page-break-before" *ngIf="noIndicatorSelected">
  <div class=" col-12 indicator-container">

    <div class="hnn_header_container">
      <h2 class="hnn_header mb-0">
        <strong>

          {{'RESULT.EXTRA_INDICATOR_RESULTS' | translate }}
        </strong>
      </h2>
    </div>

    <h4 data-test="noDataFoundHeader" class="show_message">{{'EXTRA_INDICATOR_RESULT.NO_INDICATOR_SELECTED' | translate }}</h4>


  </div>
</div>
